import { t } from '@/locale/index.js'
import { applyColumnLabels, applySearchLabels } from '@/utils/listPageI18n.js'

const DUPLICATE_COLUMNS = {
  device_list_id: 'maintenanceDuplicate.deviceId',
  code: 'maintenance.deviceCode',
  title: 'maintenance.deviceName',
  user_count: 'maintenanceDuplicate.duplicateCount',
  machinist_names: 'maintenanceDuplicate.duplicateMachinists',
  first_checkin_time: 'maintenanceDuplicate.firstCheckTime',
  last_checkin_time: 'maintenanceDuplicate.lastCheckTime',
}

export function applyMaintenanceDuplicateLabels({ searchData, columns }) {
  applySearchLabels(searchData, {
    month: { labelKey: 'maintenanceDuplicate.month' },
  })
  applyColumnLabels(columns, DUPLICATE_COLUMNS)
}

export function applyAddSpareRules(rules) {
  if (rules.name?.[0]) rules.name[0].message = t('maintenance.needPartName')
}

export { t }
